class QuantityPriceUpdater extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.moneyFormat = this.dataset.moneyFormat;
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]')?.textContent || '[]');

    const initInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
    this.currentVariant = this.variantData.find(v => v.id == parseInt(initInput?.value));

    // Dawn replaces input[name="id"] via section rendering — delegate to document
    document.addEventListener('change', this._onVariantChange = (e) => {
      if (e.target.name !== 'id') return;
      if (e.target.closest('form')?.id !== `product-form-${this.sectionId}`) return;
      this.currentVariant = this.variantData.find(v => v.id == e.target.value);
      if (this.currentVariant) this.updatePrice();
    });

    document.addEventListener('change', this._onQtyChange = (e) => {
      if (e.target.name !== 'quantity' || e.target.type !== 'number') return;
      if (this.currentVariant) this.updatePrice();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('change', this._onVariantChange);
    document.removeEventListener('change', this._onQtyChange);
  }

  updatePrice() {
    const qty = parseInt(document.getElementById(`Quantity-${this.sectionId}`)?.value) || 1;
    const price = this.currentVariant.price * qty;
    const comparePrice = this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price * qty : 0;

    const priceBlock = document.getElementById(`price-${this.sectionId}`);
    if (!priceBlock) return;

    const priceInner = priceBlock.querySelector('.price') || priceBlock;
    const onSale = comparePrice > price;
    priceInner.classList.toggle('price--on-sale', onSale);

    const badge = priceBlock.querySelector('.price__badge-sale');
    if (badge && onSale) {
      const tmpl = badge.dataset.badgeTemplate || '';
      const diff = comparePrice - price;
      const pct = comparePrice > 0 ? Math.floor((diff / comparePrice) * 100) : 0;
      // en el span, no en el badge: textContent sobre el badge se comeria el icono
      const badgeText = badge.querySelector('.price__badge-text') || badge;
      badgeText.textContent = tmpl
        .replace('[percentage]', pct > 0 ? pct + '%' : '')
        .replace('[amount]', this.formatMoney(diff));
    }

    const salePriceEl = priceBlock.querySelector('.price__sale .price-item--sale');
    if (salePriceEl) salePriceEl.innerHTML = this.formatMoney(price);

    const compareEl = priceBlock.querySelector('.price__sale .price-item--regular');
    if (compareEl) compareEl.innerHTML = this.formatMoney(comparePrice);

    const regularEl = priceBlock.querySelector('.price__regular .price-item--regular');
    if (regularEl) regularEl.innerHTML = this.formatMoney(price);
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return this.moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }
}

customElements.define('quantity-price-updater', QuantityPriceUpdater);
